import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import { Impressum, Datenschutz } from "@/pages/Legal";
import Agb from "@/pages/Agb";
import ServicePage from "@/pages/ServicePage";
import ContactPage from "@/pages/ContactPage";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/Login";
import Anfragen from "@/pages/Anfragen";
import AuthCallback from "@/pages/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { SERVICES_DATA } from "@/data/services";

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/kontakt" element={<ContactPage />} />
      {SERVICES_DATA.map((s) => (
        <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage slug={s.slug} />} />
      ))}
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/agb" element={<Agb />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/anfragen"
        element={
          <ProtectedRoute>{(user) => <Anfragen user={user} />}</ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollReset />
          <AppRouter />
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
